import { normalizeLocale } from "./localeRoutes";

/**
 * Locale handoff from the marketing site to the app.
 *
 * The two sites are separate origins with separate i18n. Once a reader crosses
 * from dociohealth.com/ru/… to app.dociohealth.com the only language signal left
 * is the browser's own — and a Russian speaker travelling on a phone bought
 * abroad usually reports English. They land on an English app, reach for
 * Safari's Translate, and the translator's DOM surgery crashes React mid-booking.
 *
 * So every link into the app carries the locale the reader is already reading in.
 * The app picks it up in `apps/web-app/src/i18n` and caches it, which is what
 * carries it across the OAuth round trip that drops the query string.
 */
export const APP_ORIGIN = "https://app.dociohealth.com";

/** The signup entry point every marketing CTA points at. */
export const APP_SIGNUP_PATH = "/auth?intent=signup";

/** Absolute, locale-tagged URL into the app. */
export function buildAppUrl(pathOrUrl: string, language: string | undefined): string {
  const url = new URL(pathOrUrl, APP_ORIGIN);
  url.searchParams.set("lang", normalizeLocale(language));
  return url.toString();
}

const APP_LINK_PATTERN = new RegExp(`${APP_ORIGIN}[^"'\\s]*`, "g");

/**
 * Tag the app links inside an article body. Article content is authored as HTML
 * strings per language, so rewriting at render time is what keeps every existing
 * and future article in step without touching the content files.
 */
export function localizeAppLinksInHtml(html: string, language: string | undefined): string {
  return html.replace(APP_LINK_PATTERN, (match) => buildAppUrl(match, language));
}
